import { Howl } from 'howler';

import PlayBackManager from './playback/main';
import Modal from './modal/main';
import ParentModal from './modal/parent';
import ExitModal from './modal/exit';


export default class Main{

    constructor(){
        this._init();
    }


    _init(){
        this.isTop = document.body.classList.contains('top');

        this.vh = window.innerHeight * 0.01;
        this.$main = document.querySelector('.js-main');
        this.audio_ext = window.navigator.userAgent.match(/Android/) ? ".ogg" : ".mp3";

        this.playback = new PlayBackManager();
        window.PLAYBACK = this.playback;

        this._setSE();
        this._setViewPort();
        if(this.isTop) this._setModal();
        
        document.body.classList.add('-ready');
    }


    _setSE(){
        const dir = this.isTop ? './' : '../';

        const btns = [...document.querySelectorAll('.js-click-sound')];
        if(btns.length < 1) return;

        this.sound = new Howl({src: [`${dir}assets/audio/common/close${this.audio_ext}`]});

        btns.forEach($btn=>{
            $btn.addEventListener('click', (e)=>{
                let targetUrl = null;

                const anchorTag = e.target.closest('a');
                if(anchorTag){
                    targetUrl = anchorTag.href;
                    e.preventDefault();
                }

                this.sound.once('end', ()=>{
                    if(targetUrl) location.href = targetUrl;
                });
                this.sound.play();
            });
        });
    }

    _setViewPort(){
        document.documentElement.style.setProperty('--vh', `${this.vh}px`);

        let debounceTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(debounceTimeout);
            
            debounceTimeout = setTimeout(() => {
                this.vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${this.vh}px`);
            }, 200);
        });
    }

    _setModal(){
        const modal = new Modal();
        window.ParentModal = new ParentModal();
        window.ExitModal = new ExitModal();
    }
}